<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Aniversariantes do Mês</h5>
    </div>

    <!-- Filtros (opcional: por dia ou nome) -->
    <div class="d-flex mb-3" style="gap:10px;">
      <input
        v-model="filters.nome"
        placeholder="Filtrar por nome"
        class="form-control"
        @input="filtrar"
      />
      <b-button variant="secondary" @click="limparFiltros">
        <i class="bi bi-funnel"></i>
      </b-button>
    </div>

    <!-- Tabela -->
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>
            <button class="btn btn-link p-0" @click="sort('nome')">
              Nome {{ arrow('nome') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('idade')">
              Idade {{ arrow('idade') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('dia_aniversario')">
              Dia Aniversário {{ arrow('dia_aniversario') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('celular')">
              celular {{ arrow('celular') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('email')">
              E-mail {{ arrow('email') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('tipo')">
              Tipo {{ arrow('tipo') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('status')">
              Status {{ arrow('status') }}
            </button>
          </th>
          <th class="text-end">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in items"
          :key="`${row.tipo}-${row.id}`"
        >
          <td>{{ row.nome }}</td>
          <td>{{ row.idade }}</td>
          <td>{{ row.dia_aniversario }}</td>
          <td>{{ row.celular }}</td>
          <td>{{ row.email }}</td>
          <td>
            <span
              :class="{
                'text-success': row.tipo === 'Aluno',
                'text-primary': row.tipo === 'Responsável',
              }"
            >
              {{ row.tipo }}
            </span>
          </td>
          <td>
            <span
              :class="{
                'text-success': row.status === 'Ativo',
                'text-primary': row.status === 'Encerrado',
                'text-danger': row.status === 'Arquivado' || row.status === 'Inativo',
              }"
            >
            {{ row.status }}
            </span>
          </td>
          <td class="text-end">
            <!-- Ícone de check, mas ainda clicável para abrir em modo leitura -->
            <i
              v-if="row.enviado"
              class="bi bi-check-circle-fill text-secondary"
              title="Ver detalhes do envio"
              style="cursor: pointer;"
              @click="onParabenizar(row)"
            />
            <!-- Ícone de gift para envios pendentes -->
            <i
              v-else
              class="bi bi-gift text-success"
              title="Enviar E-mail"
              style="cursor: pointer;"
              @click="onParabenizar(row)"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginação -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <div>Mostrando {{ startRow }} a {{ endRow }} de {{ totalItems }} registros</div>
      <div class="d-flex align-items-center" style="gap:.5rem;">
        <b-form-select v-model="limit" :options="pageOptions" size="sm" style="width:6rem" @change="onLimitChange"/>
      </div>
      <div>
        <b-pagination v-model="page" :per-page="limit" :total-rows="totalItems" size="sm" limit="5" @input="load"/>
      </div>
    </div>

    <EmailAniversario
      v-if="showEmail && selected"
      :visible="showEmail"
      :aniversariante="selected"
      :read-only="showReadOnly"
      @close="showEmail = false; showReadOnly = false"
      @sent="() => { showEmail = false; load(); }"
    />

  </div>
</template>

<script setup>
import { watch, onMounted, computed, ref } from 'vue';
import { useSortableTable } from '@/utils/useSortableTable';
import { BFormSelect, BPagination, BButton } from 'bootstrap-vue-next';
import EmailAniversario from '@/components/modals/EmailAniversario.vue';

const {
  items,
  totalItems,
  page,
  limit,
  filters,
  load,
  sort: originalSort,
  arrow
} = useSortableTable('/operacional/aniversariantes', { key: 'nome', order: 'asc' });


const pageOptions = [10, 15, 20, 25, 50];

const startRow = computed(() => (page.value - 1) * limit.value + 1);
const endRow   = computed(() => Math.min(page.value * limit.value, totalItems.value));

const showEmail  = ref(false);
const showReadOnly  = ref(false);
const selected   = ref(null);

function onParabenizar(row) {
  selected.value = row;
  showReadOnly.value = row.enviado;  
  showEmail.value = true;
}


function sort(col) {
  page.value = 1;      // volta à primeira página (opcional mas recomendado)
  items.value = [];    // limpa o array antes de recarregar
  originalSort(col);   // dispara o sort/fetch do hook
}


// recarrega sempre que mudar página ou limite
watch([page, limit], () => load());

onMounted(() => {
  filters.nome = '';
  load();
});

// filtrar por nome
function filtrar() {
  page.value = 1;
  load();
}

// limpar filtro de nome
function limparFiltros() {
  filters.value.nome = '';
  page.value = 1;
  load();
}

// ao trocar número de itens por página
function onLimitChange() {
  page.value = 1;
  load();
}

</script>

<style scoped>
:deep(.pagination-sm .page-link) {
  font-size:0.8rem; line-height:1; border-radius:0;
}
</style>
